/**
 * @generated SignedSource<<7a2cca8f6369acc0a2199155f1a0fa54>>
 * @relayHash 4d8ae05c2654945ef0cc2b646577df47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba0fbb1bfea45aac126e03879b3623a4f065cc919caa5869502bef4aa359a361

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
  widgetId: string;
};
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery$data = {
  readonly csmAi_getWidget: {
    readonly __typename: "CsmAiWidgetConfig";
    readonly standardSnippets: {
      readonly " $fragmentSpreads": FragmentRefs<"Install_AtlassianCsmWidgetConfiguration_standardSnippetsRef">;
    };
    readonly tailoredSnippets: {
      readonly " $fragmentSpreads": FragmentRefs<"Install_AtlassianCsmWidgetConfiguration_tailoredSnippetsRef">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"Install_AtlassianCsmWidgetConfiguration_clientKeysRef" | "Install_AtlassianCsmWidgetConfiguration_fragmentRef">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly helpCenter: {
    readonly helpCenterPermissionSettings: {
      readonly " $fragmentSpreads": FragmentRefs<"Install_AtlassianCsmWidgetConfiguration_accessControlDataRef">;
    };
  } | null;
};
export type HelpCenterSettingsWidgetConfigurationInstallAppQuery = {
  response: HelpCenterSettingsWidgetConfigurationInstallAppQuery$data;
  variables: HelpCenterSettingsWidgetConfigurationInstallAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "widgetId",
    "variableName": "widgetId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Literal",
    "name": "authType",
    "value": "ANONYMOUS"
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "authType",
    "value": "AUTHENTICATED"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v7 = [
  (v1/*: any*/)
],
v8 = [
  {
    "kind": "ScalarField",
    "name": "language"
  },
  {
    "kind": "ScalarField",
    "name": "code"
  }
],
v9 = [
  {
    "concreteType": "CsmAiCodeSnippet",
    "kind": "LinkedField",
    "name": "serverSnippets",
    "plural": true,
    "selections": (v8/*: any*/)
  },
  {
    "concreteType": "CsmAiCodeSnippet",
    "kind": "LinkedField",
    "name": "clientSnippets",
    "plural": true,
    "selections": (v8/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getWidget",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "Install_AtlassianCsmWidgetConfiguration_fragmentRef"
              },
              {
                "kind": "FragmentSpread",
                "name": "Install_AtlassianCsmWidgetConfiguration_clientKeysRef"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": "standardSnippets",
                  "args": (v4/*: any*/),
                  "concreteType": "CsmAiWidgetSnippets",
                  "kind": "LinkedField",
                  "name": "snippets",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "Install_AtlassianCsmWidgetConfiguration_standardSnippetsRef"
                    }
                  ],
                  "storageKey": "snippets(authType:\"ANONYMOUS\")"
                },
                "action": "THROW"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": "tailoredSnippets",
                  "args": (v5/*: any*/),
                  "concreteType": "CsmAiWidgetSnippets",
                  "kind": "LinkedField",
                  "name": "snippets",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "Install_AtlassianCsmWidgetConfiguration_tailoredSnippetsRef"
                    }
                  ],
                  "storageKey": "snippets(authType:\"AUTHENTICATED\")"
                },
                "action": "THROW"
              }
            ],
            "type": "CsmAiWidgetConfig"
          }
        ]
      },
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v7/*: any*/),
              "kind": "LinkedField",
              "name": "helpCenterPermissionSettings",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "Install_AtlassianCsmWidgetConfiguration_accessControlDataRef"
                    }
                  ],
                  "type": "HelpCenterPermissionSettings"
                }
              ]
            },
            "action": "THROW"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getWidget",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "allowedDomains"
              },
              {
                "kind": "LinkedField",
                "name": "clientKeys",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "CsmAiWidgetClientKeyStatus",
                        "kind": "LinkedField",
                        "name": "keys",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "clientKeyId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "createdTimestamp"
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiWidgetClientKeys"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              {
                "alias": "standardSnippets",
                "args": (v4/*: any*/),
                "concreteType": "CsmAiWidgetSnippets",
                "kind": "LinkedField",
                "name": "snippets",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "snippets(authType:\"ANONYMOUS\")"
              },
              {
                "alias": "tailoredSnippets",
                "args": (v5/*: any*/),
                "concreteType": "CsmAiWidgetSnippets",
                "kind": "LinkedField",
                "name": "snippets",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "snippets(authType:\"AUTHENTICATED\")"
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ],
            "type": "CsmAiWidgetConfig"
          }
        ]
      },
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterPermissionSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "accessControlType"
                  }
                ],
                "type": "HelpCenterPermissionSettings"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ba0fbb1bfea45aac126e03879b3623a4f065cc919caa5869502bef4aa359a361",
    "metadata": {},
    "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "134eeb364455426174405957cc2160df";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
